<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-3
			input-form-text(textInput='Edição', v-model='filtro.edicao', :layout="false")
		.col-md-2
			label Ano
			select.form-control(v-model="filtro.ano")
				option(value="" select=true) Todos
				option(v-for="op in opcoesAno" :value="op.value" :key="op.value") {{ op.label }}
		.col-md-7
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid"
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter"
		:DSserverFiltering="true"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate.Open'
import Permission from '@/mixins/Permission'

import InputFormText from '@/components/form/InputForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'titulo',
						operator: 'contains',
						value: this.filtro.titulo
					},
					{
						field: 'edicao',
						operator: 'contains',
						value: this.filtro.edicao
					},
					{
						field: 'ano',
						operator: 'eq',
						value: this.filtro.ano
					},
					{
						field: 'publicacao',
						operator: 'contains',
						value: this.filtro.publicacao
					}
				].filter(f => f.value)
			}
		},
		urlDataSource() {
			return `${this.$url}/v1/doem?offset=8`
		}
	},
	watch: {
		'filtro.titulo'() {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'DOEM',
			titleNew: '',
			url: '/servicos/doem/',
			columns: [
				{
					field: 'edicao',
					title: 'Edição',
					width: 120
				},
				{
					field: 'publicacao',
					title: 'Data',
					width: 100
				},
				{
					field: 'ano',
					title: 'Ano',
					width: 80
				},],
			filtro: {
				edicao: null,
				ano: '',
			},
			opcoesAno: [],
			isActive: false,
		}
	},
	methods: {
		gerarOpcoesAno() {
	const anoAtual = new Date().getFullYear()
	const anoInicial = 2014 // correspondente a value 1
	const opcoes = []

	for (let ano = anoAtual; ano >= anoInicial; ano--) {
		const value = ano - 2013 // 2014 => 1, 2015 => 2, ..., 2025 => 12, etc.
		opcoes.push({ value, label: ano.toString() })
	}

	return opcoes
},
		parse(d) {
			d.data.forEach(i => {
				if (i.publicacao) {
					const data = new Date(i.publicacao + 'T00:00:00')

					i.publicacao = data.toLocaleDateString('pt-BR')
				}

				if (i.ano && typeof i.ano === 'number') {
					i.ano = 2013 + i.ano
				}
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		setFiltro() {
			let filtro = {
				title: this.filtro.title,
			}
			localStorage.setItem('_filtroDOEM', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				titulo: null,
			}
			localStorage.setItem('_filtroDOEM', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title, 'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if (result.isConfirmed) {
				this.isActive = true
				await req(`/v1/doem/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
		this.opcoesAno = this.gerarOpcoesAno()
		let filtro = localStorage.getItem('_filtroTitulo')
			? JSON.parse(localStorage.getItem('_filtroTitulo'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus">
</style>
